import React, { Fragment } from "react";
const headerInlineStyle1 = {
  fontSize: "16px",
};
const headerInlineStyle2 = {
  fontSize: "16px",
  wordBreak: "break-word",
};

const RenderRemarksAndComments = (values) => {
  return (
    <div>
      {values.map((val) => (
        <div>{val}</div>
      ))}
    </div>
  );
};

const MultiRowTitleFormatter = (title_values, dontRotate) => {
  if (Array.isArray(title_values)) {
    return dontRotate ? (
      <div>
        {title_values.map((val) => (
          <div style={{ minWidth: "max-content" }}>{`${val}`}</div>
        ))}
      </div>
    ) : (
      <div style={{ top: "50%", position: "absolute", transform: "translate(-50%, -50%)", left: "50%", width: "200px" }}>
        {title_values.map((val) => (
          <div style={{ minWidth: "max-content" }}>{`${val}`}</div>
        ))}
      </div>
    );
  }

  return title_values;
};

const SwitchPositions = {
  normal: "nor",
  reverse: "rev",
};

export const SEPTA_TrackSectionTurnoutAndSpecialWorkInspectionReportSchema = {
  appPropertiesSection: {
    heights: {
      header1: "auto",
      header2: "155px",
    },
    classes: {
      header1: "grey-background",
      header2: "grey-background",
    },
    inlineStyle: {
      header1: headerInlineStyle1,
      header2: headerInlineStyle1,
    },
    minDataRowsCount: 4,
    columns: [
      {
        title: "Location",
        colSpan: 3,
        rowSpan: 1,
        className: "tbl-text-normal",
        columns: [
          {
            title: ["1", "Interlocking"],
            titleFormatter: MultiRowTitleFormatter,
            colSpan: 1,
            rowSpan: 1,
            className: "tbl-text-rotate-multiline",
            accessor: "inter",
          },
          {
            title: ["2", "Switch Number"],
            titleFormatter: MultiRowTitleFormatter,
            colSpan: 1,
            rowSpan: 1,
            className: "tbl-text-rotate-multiline",
            accessor: "sno",
          },
          {
            title: ["3", "Designation"],
            titleFormatter: MultiRowTitleFormatter,
            colSpan: 1,
            rowSpan: 1,
            className: "tbl-text-rotate-multiline",
            accessor: "swState",
            subAccessor: "position",
            dataFontSize: "12px",
            dataClassName: "text-bold",
            isArray: true,
            minDataRowsCount: 2,
          },
        ],
      },
      {
        title: "Switch Rail",
        colSpan: 2,
        rowSpan: 1,
        className: "tbl-text-normal",
        columns: [
          {
            title: ["4", "Point Opening"],
            titleFormatter: MultiRowTitleFormatter,
            colSpan: 1,
            rowSpan: 1,
            className: "tbl-text-rotate-multiline",
            accessor: "swState",
            subAccessor: "popen",
            isArray: true,
            minDataRowsCount: 2,
          },
          {
            title: ["5", "Condition"],
            titleFormatter: MultiRowTitleFormatter,
            colSpan: 1,
            rowSpan: 1,
            className: "tbl-text-rotate-multiline",
            accessor: "swState",
            subAccessor: "scond",
            isArray: true,
            minDataRowsCount: 2,
          },
        ],
      },
      {
        title: "Condition",
        colSpan: 6,
        rowSpan: 1,
        className: "tbl-text-normal",
        columns: [
          {
            title: ["6", "Switch Rods"],
            titleFormatter: MultiRowTitleFormatter,
            colSpan: 1,
            rowSpan: 1,
            className: "tbl-text-rotate-multiline",
            accessor: "swState",
            subAccessor: "swrod",
            isArray: true,
            minDataRowsCount: 2,
          },
          {
            title: ["7", "Braces"],
            titleFormatter: MultiRowTitleFormatter,
            colSpan: 1,
            rowSpan: 1,
            className: "tbl-text-rotate-multiline",
            accessor: "swState",
            subAccessor: "brace",
            isArray: true,
            minDataRowsCount: 2,
          },
          {
            title: ["8", "Stock Rail"],
            titleFormatter: MultiRowTitleFormatter,
            colSpan: 1,
            rowSpan: 1,
            className: "tbl-text-rotate-multiline",
            accessor: "swState",
            subAccessor: "stral",
            isArray: true,
            minDataRowsCount: 2,
          },
          {
            title: ["9", "Switch Lock"],
            titleFormatter: MultiRowTitleFormatter,
            colSpan: 1,
            rowSpan: 1,
            className: "tbl-text-rotate-multiline",
            accessor: "swlock",
          },
          {
            title: ["10", "Switch Latch"],
            titleFormatter: MultiRowTitleFormatter,
            colSpan: 1,
            rowSpan: 1,
            className: "tbl-text-rotate-multiline",
            accessor: "swState",
            subAccessor: "swlat",
            isArray: true,
            minDataRowsCount: 2,
          },
          {
            title: ["11", "Switch Target"],
            titleFormatter: MultiRowTitleFormatter,
            colSpan: 1,
            rowSpan: 1,
            className: "tbl-text-rotate-multiline",
            accessor: "swtgt",
          },
        ],
      },
      {
        title: "Gauge",
        colSpan: 3,
        rowSpan: 1,
        className: "tbl-text-normal",
        columns: [
          {
            title: ["12X", "AT Stock Rail Bend"],
            titleFormatter: MultiRowTitleFormatter,
            colSpan: 1,
            rowSpan: 1,
            className: "tbl-text-rotate-multiline",
            accessor: "atstoc",
          },
          {
            title: ["12Y", "2' into Switch Rail"],
            titleFormatter: MultiRowTitleFormatter,
            colSpan: 1,
            rowSpan: 1,
            className: "tbl-text-rotate-multiline",
            accessor: "swState",
            subAccessor: "iswrail",
            isArray: true,
            minDataRowsCount: 2,
          },
          {
            title: ["13", "Max Gauge"],
            titleFormatter: MultiRowTitleFormatter,
            colSpan: 1,
            rowSpan: 1,
            className: "tbl-text-rotate-multiline",
            accessor: "swState",
            subAccessor: "mxgage",
            isArray: true,
            minDataRowsCount: 2,
          },
        ],
      },
      {
        title: "Frog",
        colSpan: 2,
        rowSpan: 1,
        className: "tbl-text-normal",
        columns: [
          {
            title: ["14", "Condition"],
            titleFormatter: MultiRowTitleFormatter,
            colSpan: 1,
            rowSpan: 1,
            className: "tbl-text-rotate-multiline",
            accessor: "fcond",
          },
          {
            title: ["15", "Track Gauge"],
            titleFormatter: MultiRowTitleFormatter,
            colSpan: 1,
            rowSpan: 1,
            className: "tbl-text-rotate-multiline",
            accessor: "swState",
            subAccessor: "tkgage",
            isArray: true,
            minDataRowsCount: 2,
          },
        ],
      },
      {
        title: "Guard Rails",
        colSpan: 3,
        rowSpan: 1,
        className: "tbl-text-normal",
        columns: [
          {
            title: ["16", "Condition"],
            titleFormatter: MultiRowTitleFormatter,
            colSpan: 1,
            rowSpan: 1,
            className: "tbl-text-rotate-multiline",
            accessor: "swState",
            subAccessor: "grcond",
            isArray: true,
            minDataRowsCount: 2,
          },
          {
            title: ["17", "Check Gauge"],
            titleFormatter: MultiRowTitleFormatter,
            colSpan: 1,
            rowSpan: 1,
            className: "tbl-text-rotate-multiline",
            accessor: "swState",
            subAccessor: "ckgage",
            isArray: true,
            minDataRowsCount: 2,
          },
          {
            title: ["18", "Back to Back"],
            titleFormatter: MultiRowTitleFormatter,
            colSpan: 1,
            rowSpan: 1,
            className: "tbl-text-rotate-multiline",
            accessor: "swState",
            subAccessor: "btb",
            isArray: true,
            minDataRowsCount: 2,
          },
        ],
      },
      {
        title: "Condition",
        colSpan: 4,
        rowSpan: 1,
        className: "tbl-text-normal",
        columns: [
          {
            title: ["19", "Ties"],
            titleFormatter: MultiRowTitleFormatter,
            colSpan: 1,
            rowSpan: 1,
            className: "tbl-text-rotate-multiline",
            accessor: "ties",
          },
          {
            title: ["20", "Anchors"],
            titleFormatter: MultiRowTitleFormatter,
            colSpan: 1,
            rowSpan: 1,
            className: "tbl-text-rotate-multiline",
            accessor: "anch",
          },
          {
            title: ["21", "Derail"],
            titleFormatter: MultiRowTitleFormatter,
            colSpan: 1,
            rowSpan: 1,
            className: "tbl-text-rotate-multiline",
            accessor: "derl",
          },
          {
            title: ["22", "Surface"],
            titleFormatter: MultiRowTitleFormatter,
            colSpan: 1,
            rowSpan: 1,
            className: "tbl-text-rotate-multiline",
            accessor: "surf",
          },
        ],
      },
      {
        title: "Correction",
        colSpan: 3,
        rowSpan: 1,
        className: "tbl-text-normal",
        columns: [
          {
            title: ["23", "Remedial Action"],
            titleFormatter: (values) => MultiRowTitleFormatter(values, true),
            colSpan: 3,
            rowSpan: 1,
            className: "tbl-text-normal",
            accessor: "remed",
          },
        ],
      },
    ],
  },
  remarksSection: {
    heights: {
      header1: "auto",
    },
    classes: {
      header1: "grey-background",
    },
    inlineStyle: {
      header1: headerInlineStyle1,
    },
    minDataRowsCount: 4,
    columns: [
      {
        title: "",
        colSpan: 1,
        rowSpan: 1,
        className: "tbl-text-normal",
        accessor: "inter",
      },
      {
        title: "",
        colSpan: 1,
        rowSpan: 1,
        className: "tbl-text-normal",
        accessor: "sno",
      },
      {
        title: 'Remarks (see notation "B" on reverse side of form)',
        colSpan: 9,
        rowSpan: 1,
        className: "tbl-text-normal",
        accessor: "mergedRemarksAndDesc",
        dataClassName: "text-left d-block pd-left-10px",
      },
      {
        title: "Additional Remarks / Comments",
        colSpan: 15,
        rowSpan: 1,
        className: "tbl-text-normal",
        accessor: "com",
        dataClassName: "text-left d-block pd-left-10px",
      },
    ],
  },
  groupNormalReverseAndDecodeRemarks(rows = []) {
    if (!Array.isArray(rows)) rows = [];
    const getAllFields = (summary = {}, pos = undefined) => {
      let props = {};
      let remarksMap = {};
      Object.keys(summary).forEach((field) => {
        const [mainId, position, remarkno_desc] = field.split("_");
        if (Object.values(SwitchPositions).includes(pos)) {
          // Called for Switch Positions Normal or Reverse
          if (position === pos) {
            let key = mainId;
            if (!remarkno_desc) {
              // this is the main field/property and it must always exist in the data
              let remarkno = summary[`${key}_${position}_remarkno`];
              let desc = summary[`${key}_${position}_desc`];
              if (summary[field] === "O") {
                props[key] = remarkno;
              } else {
                props[key] = summary[field];
              }
            }
          }
        } else if (!position && !remarkno_desc) {
          let key = mainId;
          // this is the main field/property and it must always exist in the data
          let remarkno = summary[`${key}_remarkno`];
          let desc = summary[`${key}_desc`];
          if (summary[field] === "O") {
            props[key] = remarkno;
          } else {
            props[key] = summary[field];
          }
        }

        let isRemarkNo = field.endsWith("_remarkno");
        let isDesc = field.endsWith("_desc");
        if (isRemarkNo || isDesc) {
          let fieldKey = field.replace("_remarkno", "").replace("_desc", "");
          let subFieldKey = isRemarkNo ? "remarkno" : "desc";
          if (!remarksMap[fieldKey]) remarksMap[fieldKey] = {};
          remarksMap[fieldKey][subFieldKey] = summary[field];
        }
      });

      props.mergedRemarksAndDesc = Object.keys(remarksMap)
        .filter((key) => remarksMap[key].remarkno && remarksMap[key].desc && remarksMap[key].desc !== "")
        .map((key, index, arr) => (
          <Fragment>
            <span className="text-bold">{`${remarksMap[key].remarkno}: `}</span>
            <span>{remarksMap[key].desc}</span>
            {index !== arr.length - 1 ? <span>{","}&nbsp;&nbsp;&nbsp;&nbsp;</span> : null}
          </Fragment>
        ));

      return props;
    };

    return rows.map((row) => ({
      ...row,
      swState: [
        { position: "Normal", ...getAllFields(row.summary, SwitchPositions.normal) },
        { position: "Reverse", ...getAllFields(row.summary, SwitchPositions.reverse) },
      ],
      ...getAllFields(row.summary),
    }));
  },
  // getAllRemarksWithDescriptionMessage(rows = []) {
  //   if (!Array.isArray(rows)) rows = [];
  //   let map = {};
  //   rows.forEach((row) =>
  //     Object.keys(row.summary).forEach((key) => {
  //       let isRemarkNo = key.endsWith("_remarkno");
  //       let isDesc = key.endsWith("_desc");
  //       if (isRemarkNo || isDesc) {
  //         let fieldKey = key.replace("_remarkno", "").replace("_desc", "");
  //         let subFieldKey = isRemarkNo ? "remarkno" : "desc";
  //         if (!map[fieldKey]) map[fieldKey] = {};
  //         map[fieldKey][subFieldKey] = row.summary[key];
  //       }
  //     }),
  //   );
  //   return Object.keys(map)
  //     .filter((key) => map[key].remarkno && map[key].desc && map[key].desc !== "")
  //     .map((key) => `${map[key].remarkno}: ${map[key].desc}`)
  //     .join(", ");
  // },
};



// WEBPACK FOOTER //
// ./src/components/Reports/SEPTA/TrackSectionTurnoutAndSpecialWorkInspectionForm/SEPTA_TrackSectionTurnoutAndSpecialWorkInspectionReportSchema.js